import { atom } from "recoil";

export const topPdfViewerUrlAtom = atom<string | undefined>({
	key: "topPdfViewerUrl",
	default: undefined,
});
